import React from "react";
import { BrowserRouter as Router, Route, Routes } from "react-router-dom";
import CityCentre1ParkApp from "./Pages/city_centre_1_park/App";

export default function MainApp() {
    return (
        <Router>
            <Routes>
                <Route path="/" element={<CityCentre1ParkApp />} />
                 <Route path="*" element={<div>404 Not Found</div>} />
            </Routes>
        </Router>
    );
}
